import { FormattedMessage, useIntl } from 'react-intl';

import { useSearchParameter } from '@xing-com/crate-hooks-use-search-parameter';
import { SEARCH_STATE_PARAMS } from '@xing-com/crate-jobs-constants';

import { Tag } from '../applied-filters.styles';

export const CompanyTag: React.FC = () => {
  const { formatMessage } = useIntl();
  const { deleteSearchParameter } = useSearchParameter();

  const handleOnClickCompany = (): void => {
    deleteSearchParameter(SEARCH_STATE_PARAMS.company, { replace: false });
  };

  const ariaLabel = formatMessage(
    { id: 'JOBS_SEARCH_FILTERS_DELETE_FILTER_A11Y' },
    {
      variable_1: formatMessage({
        id: 'JOBS_SEARCH_COMPANY_CULTURE_FILTER_VALUE',
      }),
    }
  );

  return (
    <Tag onClick={handleOnClickCompany} aria-label={ariaLabel}>
      <FormattedMessage id="JOBS_SEARCH_COMPANY_CULTURE_FILTER_VALUE" />
    </Tag>
  );
};
